import { FC } from "react";
import { Typography, Divider } from "antd";
import { useLocation } from "react-router-dom";
import { routesDataMap } from "../routes/routes";

const PageHeader: FC = () => {
  const location = useLocation();
  const getPageHeader = () => {
    return routesDataMap[location.pathname] ?? "Page Does Not Exist";
  };
  return (
    <>
      <Typography.Title level={3} style={{ margin: 0 }}>
        {getPageHeader()}
      </Typography.Title>
      <Divider style={{ margin: "10px 0" }} />
    </>
  );
};

export default PageHeader;
